<template>
  <v-container id="change-password">
    <div v-if="isSala">
      <v-col class="margem">
        <v-col class="text-center">
          <h1>Primeiro Acesso</h1>
        </v-col>
        <div class="text-center">
          Bem vindo, cadastre sua senha abaixo para fazer login ao sistema.
        </div>
      </v-col>

      <login-selo v-if="isSala">
        <template v-slot:formulario>
          <FirstAccessComponents></FirstAccessComponents>
        </template>
      </login-selo>
    </div>
    <v-row v-else>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-col class="text-center">
          <h1>Primeiro Acesso</h1>
        </v-col>
        <div>
          Bem vindo, cadastre sua senha abaixo para fazer login ao sistema.
        </div>
        <FirstAccessComponents></FirstAccessComponents>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import LoginSelo from "./LoginComponents/LoginSelo";
import FirstAccessComponents from "./firstAcessComponents/Form";
import { userAPI } from "@/modules/user/components/UserAPI";
import Swal from "sweetalert2";

export default {
  components: { LoginSelo, FirstAccessComponents },
  mounted() {
    this.verificarToken();
  },
  methods: {
    verificarToken() {
      userAPI
        .verificarToken(this.$route.query.token)
        .then((_) => {})
        .catch((err) => {
          Swal.fire({
            title: "Atenção!",
            text: err.response.data,
            confirmButtonText: "Entendi",
          }).then((result) => {
            this.$router.push("/auth/login");
          });
        });
    },
  },
  computed: {
    ...mapGetters(["isSala"]),
  },
};
</script>
<style lang="scss" scoped>
.falta {
  color: red;
}
</style>
